import { Component, output } from "@angular/core";

@Component({
    selector: "revision-dropchoice",
    templateUrl: "./revision-dropchoice.component.html",
    styleUrls: ["./revision-dropchoice.component.scss"],
    standalone: false
})
export class RevisionDropchoiceComponent {
  handleRevision = output<boolean>();
}
